import { render, staticRenderFns } from "./addTags.vue?vue&type=template&id=369c3842&scoped=true&"
import script from "./addTags.vue?vue&type=script&lang=js&"
export * from "./addTags.vue?vue&type=script&lang=js&"
import style0 from "./addTags.vue?vue&type=style&index=0&id=369c3842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369c3842",
  null
  
)

export default component.exports